export default __webpack_public_path__ + "media/color/bela-41f9d2cb.svg";